import cn from 'classnames/bind';
import Link from 'next/link';

import s from './SupportLink.module.scss';

const cx = cn.bind(s);

const SupportLink = ({ className }) => (
  <Link href="/faq" className={cx('support', className)}>Support</Link>
);

export default SupportLink;
